import React, { useEffect, useCallback, useState } from "react"
import { useIntl, FormattedMessage } from "react-intl"
import { langId } from "../languages"
import { useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import classnames from "classnames"

const BackToTop = () => {
  const intl = useIntl()
  const Images = useStaticQuery(graphql`
    query {
      backToTop: file(relativePath: { eq: "images/back-to-top.png" }) {
        ...fragmentsFluidImage
      }
    }
  `)
  const [isVisible, setIsvisible] = useState(false)

  useEffect(() => {
    window.onscroll = onScroll
  }, [])

  const onScroll = useCallback(() => {
    if (
      document.body.scrollTop > 20 ||
      document.documentElement.scrollTop > 20
    ) {
      setIsvisible(true)
    } else {
      setIsvisible(false)
    }
  }, [])

  // When the user clicks on the button, scroll to the top of the document
  const goTop = useCallback(() => {
    window.top.scrollTo(0, 0)
    document.body.scrollTop = 0 // For Safari
    document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
  }, [])

  return (
    <div
      className={classnames({
        "back-to-top": true,
        "back-to-top--on": isVisible,
      })}
      onClick={goTop}
    >
      <div className="back-to-top__icon">
        <Img
          fluid={Images.backToTop.childImageSharp.fluid}
          alt={intl.formatMessage({ id: langId.BACK_TO_TOP })}
          title={intl.formatMessage({ id: langId.BACK_TO_TOP })}
        ></Img>
      </div>
      <div className="back-to-top__text">
        <FormattedMessage id={langId.TOP}></FormattedMessage>
      </div>
    </div>
  )
}

export default BackToTop
